<div>
  <div class="evidence-line" *ngIf="evidence.label">{{ evidence.label }}</div>
  <div class="evidence-line evidence-details" *ngIf="evidence.date || evidence.code">
    {{ formatEvidenceInfo(evidence) }}
  </div>
  <div class="evidence-line evidence-details" *ngIf="evidence.value">
    {{ evidence.value }}
  </div>
</div>
